import { useTranslate } from '@festina-life/ui/hooks'

import { CommandModalButton } from '../../components/commandActions/CommandModalButton'
import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import {
  type AnnotationCommandProps,
  annotationMutatorComponent,
} from './annotationCommandTypes'
import { AnnotationForm } from './AnnotationForm'

export const AmendAccessGroupAnnotationCommand = (
  props: AnnotationCommandProps,
) => {
  const translate = useTranslate()
  const { legalEntityId, tenantId } = useHook(
    'routing.general.useLegalEntityParams',
  )()
  const { festinaComponent } = props
  const componentName = translate(
    `component.${festinaComponent.toLowerCase() as Lowercase<typeof festinaComponent>}`,
  )

  const actions = useHook(
    `mutators.${annotationMutatorComponent[festinaComponent]}.useAmendAccessGroupAnnotationActions`,
  )({ tenantId, ownerId: legalEntityId, ...props })
  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId={`${festinaComponent}.AnnotationCommandData.amendAccessGroupAnnotation`}
      title={`${translate('action.amendAnnotation')}: ${componentName}`}
      commandDataForm={AnnotationForm}
      {...props}
      submit={submit}
    />
  )
}
